import { Box, Typography, styled } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  boxShadow: '0px 2px 6px rgba(151, 166, 190, 0.2)',
  borderRadius: 8,
  padding: '2rem 1.375rem 0.625rem 1.375rem',
  zIndex: 2,
  position: 'relative',
  backgroundColor: '#FFF',
}));

const GeneralInfo = styled(Box)(({ theme }) => ({
  display: 'grid',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '1fr 1fr',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
}));

const Label = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '0.875rem',
  lineHeight: 1.5,
  color: theme.palette.grey[400],
  width: '6rem',
}));

const Value = styled(Label)(({ theme }) => ({
  width: '100%',
  color: theme.palette.grey[500],
  whiteSpace: 'pre-line',
}));

const BillingDetailsContainer = styled(Box, {
  shouldForwardProp: (propName: string) => propName !== 'visible',
})<{ visible?: boolean }>(({ theme, visible }) => ({
  marginTop: '-2rem',
  padding: '4rem 1.375rem 0.625rem 1.375rem',
  backgroundColor: theme.palette.grey[200],
  zIndex: 1,
  borderRadius: 8,
  position: 'relative',

  visibility: visible ? 'visible' : 'hidden',
  opacity: visible ? 1 : 0,
  maxHeight: visible ? 1000 : 0,
  transition: `opacity 0.2s ${visible ? 'ease-in' : 'ease-out'}, max-height 0.2s ${
    visible ? 'ease-in' : 'ease-out'
  }`,
}));

export { Container, GeneralInfo, Label, Value, BillingDetailsContainer };
